export default __webpack_public_path__ + "bonus-coin.icon-a28846bae21a8b75aba42df0e1107b13.png";